import styled from 'styled-components'
import { StyledButton } from '../../../components/UI/Button/styled'
import { typoHeading4 } from '../../../lib/styles/Typography'

export const StyleTabTeaserItemContentElement = styled.div`
  flex: 1 0 45%;
  width: 45%;
  flex: unset;
  padding-block: unset;
  padding-right: unset;

  @media screen and (max-width: 859px) {
    width: 100%;
  }

  h2 {
    margin-bottom: 0.5rem;
  }

  h3 {
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ${StyledButton} {
    margin-top: 1.5rem;
  }
`
export const StyleTabTeaserItemContentWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 3rem;
  height: 100%;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    gap: 2rem;
  }

  @media screen and (max-width: 859px) {
    flex-direction: column-reverse;
    gap: 1.5rem;
  }
`

export const StyleTabTeaserItemImageWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 55%;
  justify-content: center;
  width: 100%;
  max-width: 26rem;
`

export const StyleTabTeaserItemImage = styled.img`
  display: block;
  max-height: 20rem;
  opacity: 0;
  transform: translateY(2rem) scale(0.85);
  transition: opacity 0.65s ease-in-out, transform 0.65s ease-in-out;
  width: 100%;
  object-fit: cover;

  @media screen and (max-width: 480px) {
    max-height: 14rem;
  }

  &.animate {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

export const StyleTabTeaserItemProse = styled.div`
  ul {
    li {
      color: var(--c-theme-3);

      p {
        color: ${({ theme }) => theme.colors.black[1]};
      }
    }
  }
`

export const StyleTabTeaserItemHeadline = styled.h2`
  color: var(--black-black-1, #0D0D0D);
  font-family: Source Sans Pro;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 115%;
`
